import React, {useEffect} from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faCircleCheck } from '@fortawesome/free-solid-svg-icons';

// Components

import Alert from '../../UI/Alert/Alert';

import './Styles.scss';

export default function PermissionsList({data, formik, fieldName}) {

    const handlePermissionSelect = (item) => {
        const optionsArray = [...formik.values[fieldName]];
        if (optionsArray.includes(item)) {
            let index = optionsArray.indexOf(item);
            optionsArray.splice(index, 1);
        } else {
            optionsArray.push(item);
        }

        formik.setFieldValue(fieldName, optionsArray);
    }

    return (
        <div className='permissions-list'>

            <p>Seleccione permisos</p>

            <ul>
                {data.map((option, i) => (
                    <li key={i}>
                        <button
                            role="button" 
                            className={formik.values[fieldName]?.includes(option.value) ? 'permissions-list-selected' : ''}
                            onClick={() => handlePermissionSelect(option.value)}
                        >
                            <FontAwesomeIcon className='permissions-list-icon' icon={formik.values[fieldName]?.includes(option.value) ? faCircleCheck : faCircle} />
                            <span>{option.label}</span>
                        </button>
                    </li>
                ))}
            </ul>

            {formik.touched[fieldName] && formik.errors[fieldName] &&
            <Alert message={formik.errors[fieldName]} isError />}

        </div>
    )
}
